module.exports = __webpack_public_path__ + "static/media/pf.141b0361.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pf.svg
// module id = 2185
// module chunks = 0